<template>
  <section style="position: relative;">
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div class="col-sm-12 text-right common_save_btn">
      <router-link :to="{ name: 'helperAndDriver' }">
        <button class="mr-5 btn btn-default" type="button"> Cancel </button>
      </router-link>
      <button class="mr-2 btn gradientbt" type="submit" @click="createHelperAndDriver(formstate)" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'"> Save </button>
      <button class="btn gradientbt mr-5" type="submit" @click="updateHelperAndDriver" :disabled="!(
            (formstate.$dirty || isUserRoleChange || isFileChange) &&
            formstate.$valid
            )
            " v-if="$route.params && $route.params._id != '0'"> Update </button>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body details_scrollbar">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div class="scroll">
            <div id="details" class="common_bdr">
              <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                        <div class="form_dierction_msg">
                          <label>City <span class="requred">*</span>
                          </label>
                          <span>Select your City</span>
                        </div>
                        <div class="input_field_validation">
                          <select required name="cityId" class="form-control" :disabled="($route.params && $route.params._id && $route.params._id != '0') || isCityDisable" v-model="helperAndDriver.cityId">
                            <option value="" disabled>Select City Name</option>
                            <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                            </option>
                          </select>
                          <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">This is required field</div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.firstName)">
                        <div class="form_dierction_msg">
                          <label>First Name <span class="requred">*</span>
                          </label>
                          <span>Please fill your First Name</span>
                        </div>
                        <div class="input_field_validation">
                          <input type="text" name="firstName" class="form-control" @input="capitalizeFirstName()" required v-model="helperAndDriver.firstName" placeholder="First Name" pattern="^(?=[A-Z])[A-Za-z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                          <field-messages name="firstName" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">First Name is a required field</div>
                            <div slot="pattern"> Alphabets are allowed and upto 25 characters. </div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.lastName)">
                        <div class="form_dierction_msg">
                          <label>Last Name <span class="requred">*</span>
                          </label>
                          <span>Please fill your Last Name</span>
                        </div>
                        <div class="input_field_validation">
                          <input type="text" @input="capitalizeLastName()" name="lastName" class="form-control" required v-model="helperAndDriver.lastName" placeholder="Last Name" pattern="^(?=[A-Z])[A-Za-z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                          <field-messages name="lastName" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Last Name is a required field</div>
                            <div slot="pattern"> Alphabets are allowed and upto 25 characters. </div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.role)">
                        <div class="form_dierction_msg">
                          <label>User Role Type <span class="requred">*</span>
                          </label>
                          <span>Select your User Role Type</span>
                        </div>
                        <div class="input_field_validation">
                          <select required name="role" v-model="helperAndDriver.role" class="form-control" @change="getRolesPermission($event.target.value)">
                            <option value="" disabled>Select User Role Type</option>
                            <option v-for="role in roles" :value="role._id" :selected="role &&
                                             helperAndDriver.role &&
                                             role._id === helperAndDriver.role
                                             ">{{ role.role }}</option>
                          </select>
                          <field-messages name="role" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">User Role is required field</div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.mobile)">
                        <div class="form_dierction_msg">
                          <label>Contact Number <span class="requred">*</span>
                          </label>
                          <span>Please fill your Contact Number</span>
                        </div>
                        <div class="input_field_validation">
                          <input required maxlength="10" v-model="helperAndDriver.mobile" type="string" class="form-control" name="mobile" placeholder="Contact" pattern="[78965][0-9]{9}" />
                          <field-messages name="mobile" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">This is required field</div>
                            <div slot="pattern">Contact number is invalid</div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.idProof)">
                        <div class="form_dierction_msg">
                          <label>ID Proof 1</label>
                          <span>Please fill upload your ID Proof 1</span>
                        </div>
                        <div class="input_field_validation">
                          <label for="fileName" class="custom-file-upload">
                            <img v-if="!isFileChange1" src="../../../../static/img/sidebarIcon/downloadIcon.png" alt="downloadIcon.png" style="float: right;">
                            <img v-if="isFileChange1" src="../../../../static/img/sidebarIcon/showIcon.png" alt="showIcon.png">
                            <span v-if="isFileChange1">{{ this.licenceName1 }}</span>
                          </label>
                          <input type="file" id="fileName" accept="image/png,image/jpeg,image/jpg,application/pdf" name="otherInfo" class="form-control" @change="onDocumentchanged1" />
                          <field-messages name="otherInfo" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required"> Please upload less than 5mb ID Proof 1 </div>
                          </field-messages>
                          <div class="border p-2 mt-3" v-if="$route.params &&
                                          $route.params._id != '0' &&
                                          helperAndDriver.idFront
                                          ">
                            <a v-bind:href="helperAndDriver.idFront" target="_blank"> View </a>
                          </div>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.idProof)">
                        <div class="form_dierction_msg">
                          <label>ID Proof 2</label>
                          <span>Please fill upload your ID Proof 2</span>
                        </div>
                        <div class="input_field_validation">
                          <label for="fileName1" class="custom-file-upload">
                            <img v-if="!isFileChange2" src="../../../../static/img/sidebarIcon/downloadIcon.png" alt="downloadIcon.png" style="float: right;">
                            <img v-if="isFileChange2" src="../../../../static/img/sidebarIcon/showIcon.png" alt="showIcon.png">
                            <span v-if="isFileChange2">{{ this.licenceName2 }}</span>
                          </label>
                          <input type="file" id="fileName1" accept="image/png,image/jpeg,image/jpg,application/pdf" name="otherInfo" class="form-control" @change="onDocumentchanged2" />
                          <field-messages name="otherInfo" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required"> Please upload less than 5mb ID Proof 2 </div>
                          </field-messages>
                          <div class="border p-2 mt-3" v-if="$route.params &&
                                          $route.params._id != '0' &&
                                          helperAndDriver.idBack
                                          ">
                            <a v-bind:href="helperAndDriver.idBack" target="_blank"> View </a>
                          </div>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <!-- :custom="{ email: emailValidator }" -->
                    <div class="col-sm-12">
                      <validate auto-label class="form-group" :class="fieldClassName(formstate.email)" :custom="{ email: emailValidator }">
                        <div class="form_dierction_msg">
                          <div :class="{
                                          'required-field':
                                          roleName === 'Surveyor' ||
                                          roleName === 'Plant Manager' ||
                                          roleName === 'Dump Yard Manager' ||
                                          roleName === 'Supervisor' ||
                                          roleName === 'Report Manager' ||
                                          roleName === 'Monitoring Manager' ||
                                          roleName === 'City SubAdmin',
                                          }">
                            <label>Email</label>
                            <span>Please fill your Email</span>
                          </div>
                        </div>
                        <div class="input_field_validation">
                          <input :required="roleName === 'Surveyor' ||
                                          roleName === 'Plant Manager' ||
                                          roleName === 'Dump Yard Manager' ||
                                          roleName === 'Supervisor' ||
                                          roleName === 'Report Manager' ||
                                          roleName === 'Monitoring Manager' ||
                                          roleName === 'City SubAdmin'
                                          ? true
                                          : false
                                          " v-model="helperAndDriver.email" type="email" class="form-control" name="email" placeholder="Email" />
                          <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">This is required field</div>
                            <div slot="email">Email is invalid</div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12" v-if="showDriverDetails">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.expiryDate)">
                        <div class="form_dierction_msg">
                          <label for="expiryDate">Expiry Date</label>
                          <span>Select your Expiry Date</span>
                        </div>
                        <div class="input_field_validation">
                          <date-picker id="expiryDate" :not-before="beforeDisable" v-model="helperAndDriver.expiryDate" lang="en" name="expiryDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                          <field-messages name="expiryDate" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Expiry date is a required field</div>
                            <div slot="pattern">Expiry date is invalid</div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.licenceNumber)">
                        <div class="form_dierction_msg">
                          <label>License Number <span class="requred">*</span>
                          </label>
                          <span>Please fill your License Number</span>
                        </div>
                        <div class="input_field_validation">
                          <input type="text" name="licenceNumber" maxlength="16" class="form-control" required v-model="helperAndDriver.licenceNumber" placeholder="License Number" pattern="^[a-zA-Z0-9 -]{0,16}[^\s]$" />
                          <field-messages name="licenceNumber" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required"> License Number is a required field </div>
                            <div slot="pattern"> License Number should have only alphabet and numeric characters without special. </div>
                          </field-messages>
                        </div>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12" v-if="showPin">
                  <div class="colmn_inner">
                    <div class="col-sm-12">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.pin)">
                        <div class="form_dierction_msg">
                          <label>PIN <span class="requred">*</span>
                          </label>
                          <span>Please fill your PIN</span>
                        </div>
                        <div class="input_field_validation">
                          <input type="string" minlength="4" maxlength="4" name="pin" class="form-control" required v-model="helperAndDriver.pin" placeholder="PIN" pattern="^\d{4}$" />
                          <field-messages name="pin" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required"> PIN is a required field. </div>
                            <div slot="pattern"> Numbers are allowed. </div>
                          </field-messages>
                          </div>
                    </validate>
                  </div>

                  </div>
                  <div class="col-sm-12" v-if="showPasswordField">
                    <div class="col-sm-6">
                      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.pin)">
                        <label>Password <span class="requred">*</span>
                        </label>
                        <div class="input_relative">
                          <input type="password" id="password" class="form-control" maxlength="25" name="pin" required placeholder="Password" v-model="helperAndDriver.pin" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$#!%*?&]{8,}$" />
                          <a class="fa fa-eye passwordView" role="button" v-on:click="showPassword"></a>
                        </div>
                        <field-messages name="pin" show="$touched || $submitted" class="form-control-feedback">
                          <div slot="required"> Password is a required field </div>
                          <div slot="pattern"> Password should have at least one uppercase letter, one lowercase letter, one number and one special character. ( eg: Xyz@1234 ) </div>
                        </field-messages>
                      </validate>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12" v-if="showDriverDetails">
                    <validate auto-label class="form-group" :class="fieldClassName(formstate.helperAndDriverGpsId)">
                      <label>Driver Device Identifier</label>
                      {{ ` : ${this.helperAndDriverGpsId} ` }}
                      <div class="captcha-input-container" style="position: relative">
                        <button v-if="!this.helperAndDriverGpsId" type="button" class="mr-2 btn gradientbt" @click="refreshCaptcha" style="position: absolute"> Generate </button>
                      </div>
                      <field-messages name="helperAndDriverGpsId" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">PIN is a required field.</div>
                        <div slot="pattern">Numbers are allowed.</div>
                      </field-messages>
                      </validate>
                    </div>
              </vue-form>
            </div>
            <!-- v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]" -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import axios from "axios";
  import {
    eventBus,
    formService,
    helperAndDriverService,
    authService,
    fileService,
  } from "../../../services";
  import {
    EVENTS
  } from "../../../config";
  import {
    USER_ROLES
  } from "../../../config";
  export default {
    name: "helperAndDriverCreate",
    data() {
      return {
        isGpsSelected: false,
        isCityDisable: false,
        beforeDisable: new Date(),
        isFileChange: false,
        isUserRoleChange: false,
        isFileChange1: false,
        isFileChange2: false,
        ready: false,
        USER_ROLES: USER_ROLES,
        licenceName2: "",
        licenceName1: "",
        loading: false,
        showDriverDetails: null,
        showPasswordField: false,
        showPin: null,
        flash: false,
        flashType: null,
        flashMessage: "",
        EVENTS: EVENTS,
        rolesss: {},
        helperAndDriverGpsId: "",
        formstate: {},
        helperAndDriver: {
          cityId: "",
          role: "",
        },
        oldHelperAndDriver: {},
        helperAndDriverId: [],
        docs1: null,
        docs2: null,
        // roles: ["Driver", "Helper", "Surveyor"],
        roles: [],
        driverStatus: true,
        data: {},
        staffInfo: {},
        selectedroleId: "",
        selectedrolePermissions: [],
        roleName: "",
        citys: {},
        mode: "create",
        roleId: "",
        // userId: this.$route.params._id,
      };
    },
    methods: {
      fieldClassName: formService.fieldClassName,
      emailValidator: formService.emailValidator,
      capitalizeFirstLetter(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      },
      capitalizeFirstName() {
        this.helperAndDriver.firstName = this.capitalizeFirstLetter(this.helperAndDriver.firstName);
      },
      capitalizeLastName() {
        this.helperAndDriver.lastName = this.capitalizeFirstLetter(this.helperAndDriver.lastName);
      },
      showPassword() {
        let x = document.getElementById("password");
        x.type === "password" ? x.type = "text" : x.type = "password";
      },
      getCityList() {
        if (this.$store.state.auth.user.role.key === "cityAdmin" || this.$store.state.auth.user.role.key === "subCityAdmin") {
          const {
            _id,
            cityName
          } = this.$store.state.auth.user.cityId;
          this.citys = [{
            id: _id,
            name: cityName
          }];
          this.helperAndDriver["cityId"] = _id;
          this.isCityDisable = true;
          if (this.mode === "create") {
            this.getRoles();
          }
          return;
        }
        this.loading = true;
        const params = {};
        let cityList = [];
        // params.page = 1;
        // params.limit = 999;
        this.$cityRepository.collectionCitysList(params).then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            if (element.status === true) {
              cityList.push({
                name: element.cityName,
                id: element._id,
              });
            }
          });
          cityList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.citys = cityList;
          if (this.mode === "create") {
            this.getRoles();
          }
        }).catch((error) => {
          this.loading = false;
          this.$snotify.error("Get citys list failed", "Error!");
        });
      },
      onChange(event) {
        let status = event.target.value;
        if (status == "helper") {
          this.driverStatus = false;
        } else {
          this.driverStatus = true;
        }
      },
      refreshCaptcha() {
        this.isGpsSelected = true;
        let randomCode = "";
        const length = 15;
        for (let i = 0; i < length; i++) {
          randomCode += Math.floor(Math.random() * 10);
        }
        this.helperAndDriverGpsId = randomCode;
      },
      getRolesPermission(role) {
        let params = {};
        return this.$roleRepository.list(params).then((response) => {
          this.rolesss = response.data.docs;
          let roleId = this.rolesss.filter((el) => el._id === role);
          this.roleName = roleId[0].name;
          this.roleName == "Supervisor" || this.roleName == "Report Manager" || this.roleName === "Monitoring Manager" ? (this.showPasswordField = true) : (this.showPasswordField = false || this.roleName === "City SubAdmin" ? (this.showPasswordField = true) : (this.showPasswordField = false));
          if (this.roleName !== "Driver") {
            this.showDriverDetails = false;
          } else {
            this.showDriverDetails = true;
          }
          if (this.roleName === "Surveyor" || this.roleName === "Driver" || this.roleName === "Helper") {
            this.showPin = true;
          } else {
            this.showPin = false;
          }
          this.selectedrolePermissions = roleId[0].permissions;
        }).catch((error) => {
          this.$snotify.error("Get roles failed", "Error!");
        });
      },
      getRoles() {
        let params = {};
        return this.$roleRepository.list(params).then((response) => {
          response.data.docs.forEach((elemant) => {
            let value = {};
            if (elemant.rank > 2) {
              value["role"] = elemant.name;
              value["_id"] = elemant._id;
              this.roles.push(value);
            }
            this.roles = this.roles.filter(
              (ele) => ele.role !== "Plant Manager" && ele.role !== "Dump Yard Manager");
          });
          if (this.mode == "edit") {
            this.getRolesPermission(this.roleId._id);
            let selectedRole = this.roles.filter((el) => el._id === this.roleId._id);
            this.roleName = selectedRole[0].role;
            if (selectedRole[0].role !== "Driver") {
              this.showDriverDetails = false;
            } else {
              this.showDriverDetails = true;
            }
            if (selectedRole[0].role === "Surveyor" || selectedRole[0].role === "Driver" || selectedRole[0].role === "Helper") {
              this.showPin = true;
            } else {
              this.showPin = false;
            }
          }
        }).catch((error) => {
          this.$snotify.error("Get roles failed", "Error!");
        });
      },
      getHelperAndDriver() {
        const id = this.$route.params._id;
        this.mode = "edit";
        return authService.getUser(id).then((response) => {
          let data = response.data;
          this.helperAndDriver = response.data;
          this.roleId = response.data.role;
          this.helperAndDriverGpsId = response.data.assignGpsId ? response.data.assignGpsId : "";
          this.helperAndDriver["cityId"] = this.helperAndDriver.cityId ? this.helperAndDriver.cityId._id : null;
          this.helperAndDriver["role"] = this.roleId ? this.roleId._id : null;
          this.oldHelperAndDriver = _.cloneDeep(this.helperAndDriver);
          this.getRoles();
          this.$store.dispatch("setBreadcrumbTitle", this.helperAndDriver.firstName);
        }).catch((error) => {
          this.$snotify.error("Get helperAndDriver failed", "Error!");
        });
      },
      onDocumentchanged1(event) {
        this.licenceName1 = event.target.files[0].name
        const fileName = document.getElementById("fileName");
        if (
          ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
          if (event.target.files[0].size > 1024 * 1024 * 5) {
            this.$snotify.error("File Size max limit of 5 MB", "Error!");
            fileName.value = "";
            event.preventDefault();
            return;
          } else {
            this.docs1 = event.target.files[0];
            if (this.docs1) {
              this.isFileChange = true;
              this.isFileChange1 = true
            } else {
              this.isFileChange = false;
              this.isFileChange1 = false
            }
            this.helperAndDriver.idProof = event.target.files[0]["name"];
          }
        } else {
          this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
          fileName.value = "";
        }
      },
      onDocumentchanged2(event) {
        this.licenceName2 = event.target.files[0].name
        const fileName = document.getElementById("fileName1");
        if (
          ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(event.target.files[0]["type"])) {
          if (event.target.files[0].size > 1024 * 1024 * 5) {
            this.$snotify.error("File Size max limit of 5 MB", "Error!");
            fileName.value = "";
            event.preventDefault();
            return;
          } else {
            this.docs2 = event.target.files[0];
            if (this.docs2) {
              this.isFileChange = true;
              this.isFileChange2 = true;
            } else {
              this.isFileChange = false;
              this.isFileChange2 = false;
            }
            this.helperAndDriver.idProof = event.target.files[0]["name"];
          }
        } else {
          this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
          fileName.value = "";
        }
      },
      async uploadDocument1() {
        let docsArr = [];
        docsArr.push(this.docs1);
        const response = await fileService.fileUpload(docsArr, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response.data;
      },
      async uploadDocument2() {
        let docsArr = [];
        docsArr.push(this.docs2);
        const response = await fileService.fileUpload(docsArr, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response.data;
      },
      async createHelperAndDriver(form) {
        debugger
        
        if (this.docs1 != null) {
          let uploadedFileLocation = await this.uploadDocument1();
          if (uploadedFileLocation !== "") {
            this.helperAndDriver["idFront"] = uploadedFileLocation[0].Location;
          }
        }
        if (this.docs2 != null) {
          let uploadedFileLocation = await this.uploadDocument2();
          if (uploadedFileLocation !== "") {
            this.helperAndDriver["idBack"] = uploadedFileLocation[0].Location;
          }
        }
        this.staffInfo = {};
        this.data = {};
        this.loading = true;
        this.data["cityId"] = this.helperAndDriver["cityId"];
        this.data["email"] = this.helperAndDriver["email"];
        this.data["firstName"] = this.helperAndDriver["firstName"];
        this.data["lastName"] = this.helperAndDriver["lastName"];
        this.data["mobile"] = this.helperAndDriver["mobile"];
        this.data["permissions"] = this.selectedrolePermissions;
        this.data["role"] = this.helperAndDriver["role"];
        this.data["idFront"] = this.helperAndDriver["idFront"];
        if (this.helperAndDriver.idBack) {
          this.data["idBack"] = this.helperAndDriver["idBack"];
        }
        if (this.roleName === "Driver") {
          this.data["licenceNumber"] = this.helperAndDriver["licenceNumber"];
          this.data["expiryDate"] = this.helperAndDriver["expiryDate"];
        }
        if (this.roleName === "Driver" || this.roleName === "Surveyor" || this.roleName === "Helper" || this.roleName === "Supervisor" || this.roleName === "Report Manager" || this.roleName === "Monitoring Manager" || this.roleName === "City SubAdmin") {
          this.data["password"] = this.helperAndDriver["pin"];
        }
        this.staffInfo["user"] = this.data;
        this.data["assignGpsId"] = this.helperAndDriverGpsId;
        this.staffInfo["registerType"] = "Register";
        return helperAndDriverService.addHelperAndDriver(this.staffInfo).then((response) => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success(`The ${this.staffInfo.user.firstName} has been added successfully.`);
          this.$router.push("/helperAndDriver");
        }).catch((error) => {
          this.loading = false;
          if (error.data.message == "Mobile Number already in use.") {
            var errorMessage = "Contact Number is Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.message == "Email already in use.") {
            var errorMessage = "Email Id is Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.message == "Licence Number already in use.") {
            var errorMessage = "Licence Number is Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else {
            this.$snotify.error("Staff Create Failed.", "Error!");
          }
        });
      },
      onChecked(option) {
        this.helperAndDriver.cityId = option.value
      },
      clearChanges() {
        this.helperAndDriver = _.cloneDeep(this.oldHelperAndDriver);
        this.formstate._reset();
      },
      async updateHelperAndDriver() {
        if (this.docs1 != null) {
          let uploadedFileLocation = await this.uploadDocument1();
          if (uploadedFileLocation !== "") {
            this.helperAndDriver["idFront"] = uploadedFileLocation[0].Location;
          }
        }
        if (this.docs2 != null) {
          let uploadedFileLocation = await this.uploadDocument2();
          if (uploadedFileLocation !== "") {
            this.helperAndDriver["idBack"] = uploadedFileLocation[0].Location;
          }
        }
        this.staffInfo = {};
        this.data = {};
        this.loading = true;
        this.data["cityId"] = this.helperAndDriver["cityId"];
        if (this.helperAndDriver.email) {
          this.data["email"] = this.helperAndDriver["email"];
        }
        this.data["mobile"] = this.helperAndDriver["mobile"].toString();
        this.data["firstName"] = this.helperAndDriver["firstName"];
        this.data["lastName"] = this.helperAndDriver["lastName"];
        this.data["permissions"] = this.selectedrolePermissions;
        this.data["role"] = this.helperAndDriver["role"];
        this.data["idFront"] = this.helperAndDriver["idFront"];
        this.data["assignGpsId"] = this.helperAndDriverGpsId;
        if (this.helperAndDriver.idBack) {
          this.data["idBack"] = this.helperAndDriver["idBack"];
        }
        if (this.roleName === "Driver") {
          this.data["licenceNumber"] = this.helperAndDriver["licenceNumber"];
          this.data["expiryDate"] = this.helperAndDriver["expiryDate"];
        }
        if (this.roleName === "Driver" || this.roleName === "Surveyor" || this.roleName === "Helper" || this.roleName === "Supervisor" || this.roleName === "Report Manager" || this.roleName === "Monitoring Manager" || this.roleName === "City SubAdmin") {
          this.data["password"] = this.helperAndDriver["pin"];
        }
        this.data["_id"] = this.$route.params._id;
        this.staffInfo["user"] = this.data;
        this.staffInfo["registerType"] = "Register";
        return helperAndDriverService.updateHelperAndDriver(this.staffInfo, this.oldHelperAndDriver).then((response) => {
          this.loading = false;
          this.flash = false;
          this.formstate._reset();
          this.oldHelperAndDriver = _.cloneDeep(this.helperAndDriver);
          this.$snotify.success(`The ${this.staffInfo.user.firstName} has been updated successfully.`);
          this.$router.push("/helperAndDriver");
        }).catch((error) => {
          this.loading = false;
          if (error.data.message == "Mobile Number already in use.") {
            var errorMessage = "Contact Number Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.message == "Email already in use.") {
            var errorMessage = "Email Id Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.message == "Licence Number already in use.") {
            var errorMessage = "Licence Number Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.duplicateKey == "email") {
            var errorMessage = "Email Id Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.duplicateKey == "mobile") {
            var errorMessage = "Contact Number Already Exist!";
            this.$snotify.error(errorMessage, "Error!");
          } else if (error.data.message == "Can not change role of ongoing, pending and upcoming") {
            var errorMessage = "Can not change role of ongoing, pending and upcoming!";
            this.$snotify.error(errorMessage, "Error!");
          } else {
            this.$snotify.error("Staff Update Failed", "Error!");
          }
        });
      },
    },
    created() {
      const promises = [];
      this.loading = true;
      if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
        promises.push(this.getHelperAndDriver());
      }
      Promise.all(promises).then(() => {
        this.loading = false;
        this.ready = true;
      }).catch((error) => {
        this.loading = false;
        this.$snotify.error("Create helperAndDriver failed", "Error!");
      });
    },
    // fieldClassName: function(field) {
    //   if (!field) {
    //     return "";
    //   }
    //   if ((field.$touched || field.$submitted) && field.$valid) {
    //     return "has-success";
    //   }
    //   if ((field.$touched || field.$submitted) && field.$invalid) {
    //     return "has-danger";
    //   }
    // },
    mounted() {
      this.getCityList();
      eventBus.$on("cityIdChanged", this.onChecked);
      if (this.$store.state.auth.user.role.key !== "cityAdmin" || this.$store.state.auth.user.role.key !== "subCityAdmin") {
        this.isCityDisable = true;
        this.helperAndDriver.cityId = this.$store.state.auth.cityId.value;
      }
      // this.getRoles();
    },
    beforeDestroy() {
      eventBus.$off("cityIdChanged", this.onChecked);
    },
    // computed: {
    //     ...mapState({
    //         user: state => state.auth.user,
    //     })
    // }
  };
</script>
<style scoped>
  .required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
  }

  .form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
  }

  input[type="file"] {
    display: none;
  }

  .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    position: relative;
  }

  .has-danger {
    color: red;
  }

  .mt {
    margin-top: 7px;
  }

  .requred {
    color: red;
  }

  .gradientbt {
    background: #35A2FE;
    color: white;
  }

  .form-group {
    display: flex;
    align-items: center;
  }

  /* .form-group label{
   flex: 0 0 50%;
   } */
  .common_save_btn {
    position: absolute;
    top: -45px;
  }

  .input_field_validation {
    display: flex;
    flex-direction: column;
    flex: 0 0 60%;
  }

  .form_dierction_msg {
    flex: 0 0 30%;
    display: flex;
    flex-direction: column;
  }

  .scroll {
    height: 100%;
    overflow-x: hidden;
    /* 
   height: 300px;
   overflow: auto; */
  }
</style>



// WEBPACK FOOTER //
// helperAndDriverCreate.vue?33975e35